'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = 'src/components/modal-overlay.js';
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _reactRedux = require('react-redux');
var _glamorous = require('glamorous');
var _glamorous2 = _interopRequireDefault(_glamorous);
var _actions = require('../actions');
var actions = _interopRequireWildcard(_actions);
var _selectors = require('../selectors');
var selectors = _interopRequireWildcard(_selectors);
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
var modalOverlayWrapperStyles = function modalOverlayWrapperStyles(_ref) {
  var active = _ref.active,
    zIndex = _ref.zIndex,
    _ref$backgroundColor = _ref.backgroundColor,
    backgroundColor = _ref$backgroundColor === undefined ? '#0f0f0f' : _ref$backgroundColor,
    _ref$opacity = _ref.opacity,
    opacity = _ref$opacity === undefined ? 0.5 : _ref$opacity;
  return {
    display: active ? 'block' : 'none',
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: zIndex,
    backgroundColor: backgroundColor,
    opacity: opacity
  };
};
var ModalOverlayWrapper = _glamorous2.default.div(modalOverlayWrapperStyles);
ModalOverlay.propTypes = {
  active: _propTypes.bool.isRequired,
  remove: _propTypes.func.isRequired,
  backgroundColor: _propTypes.string,
  zIndex: _propTypes.number
};
ModalOverlayWrapper.defaultProps = {
  backgroundColor: '#000',
  opacity: '0.7',
  zIndex: 999999998
};
function ModalOverlay(_ref2) {
  var remove = _ref2.remove,
    props = _objectWithoutProperties(_ref2, ['remove']);
  return _react2.default.createElement(ModalOverlayWrapper, Object.assign({
    role: 'button',
    tabIndex: 0,
    onClick: remove
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 42
    },
    __self: this
  }));
}
exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    active: selectors.modalActive(state)
  };
}, {
  remove: actions.hideModal
})(ModalOverlay);